(function () {
  'use strict';

  var theme = window.theme || { routes: {}, cartType: 'drawer' };
  var root = (theme.routes.root_url || '/').replace(/\/?$/, '/');

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var toggle = document.querySelector('[aria-controls="' + id + '"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    var focusable = d.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      var toggle = document.querySelector('[aria-controls="' + d.id + '"]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); return; }

    var cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && theme.cartType === 'drawer' && !document.querySelector('[data-cart-page]')) {
      e.preventDefault(); openDrawer('CartDrawer'); return;
    }

    var searchToggle = e.target.closest('[data-search-toggle]');
    if (searchToggle) {
      var bar = document.getElementById('HeaderSearch');
      var open = bar.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) bar.querySelector('input[type="search"]').focus();
      return;
    }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      changeLine(qtyBtn.getAttribute('data-line'), parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) changeLine(input.getAttribute('data-line'), Math.max(0, parseInt(input.value, 10) || 0));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawers();
      var bar = document.getElementById('HeaderSearch');
      if (bar) bar.classList.remove('is-open');
    }
  });

  /* ---------- Cart ---------- */
  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }

  function renderDrawer(html) {
    if (!html) return;
    var wrap = document.getElementById('shopify-section-cart-drawer');
    if (!wrap) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-cart-drawer');
    wrap.innerHTML = fresh ? fresh.innerHTML : html;
  }

  function changeLine(line, quantity) {
    var onCartPage = !!document.querySelector('[data-cart-page]');
    fetch(theme.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (onCartPage) { window.location.reload(); return; }
        updateCount(cart.item_count);
        if (cart.sections) renderDrawer(cart.sections['cart-drawer']);
      })
      .catch(function () { window.location.href = theme.routes.cart_url; });
  }

  function addToCart(form, button) {
    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) errorEl.hidden = true;
    button.classList.add('is-loading');
    var data = new FormData(form);
    data.append('sections', 'cart-drawer');
    data.append('sections_url', window.location.pathname);

    fetch(theme.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: data })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        button.classList.remove('is-loading');
        if (res.status) {
          if (errorEl) { errorEl.textContent = res.description || res.message; errorEl.hidden = false; }
          return;
        }
        if (theme.cartType === 'page') { window.location.href = theme.routes.cart_url; return; }
        if (res.sections) renderDrawer(res.sections['cart-drawer']);
        fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) { updateCount(cart.item_count); });
        openDrawer('CartDrawer');
      })
      .catch(function () { button.classList.remove('is-loading'); form.submit(); });
  }

  /* ---------- Product forms ---------- */
  function initProduct(section) {
    var form = section.querySelector('[data-product-form]');
    var json = section.querySelector('[data-variant-json]');
    if (!form || !json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (err) { return; }

    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    var stockNote = form.querySelector('[data-stock-note]');
    var thresholdEl = section.querySelector('[data-low-stock-threshold]');
    var threshold = thresholdEl ? parseInt(thresholdEl.getAttribute('data-low-stock-threshold'), 10) : 0;
    var priceWrap = section.querySelector('[data-price]');
    var stickyPrice = section.parentNode.querySelector('[data-sticky-price]');
    var radios = form.querySelectorAll('input[data-option-index]');

    function selected() {
      var opts = [];
      radios.forEach(function (r) { if (r.checked) opts[parseInt(r.getAttribute('data-option-index'), 10)] = r.value; });
      return opts;
    }
    function find(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }

    function markAvailability(opts) {
      radios.forEach(function (r) {
        var idx = parseInt(r.getAttribute('data-option-index'), 10);
        var test = opts.slice(); test[idx] = r.value;
        var match = find(test);
        r.classList.toggle('is-unavailable', !match || !match.available);
      });
    }

    function update(pushUrl) {
      var opts = selected();
      var v = find(opts);
      opts.forEach(function (val, i) {
        var label = form.querySelector('[data-option-selected="' + i + '"]');
        if (label) label.textContent = val;
      });
      markAvailability(opts);

      if (!v) {
        addBtn.disabled = true; addLabel.textContent = 'Unavailable';
        if (stockNote) stockNote.textContent = '';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';

      if (stockNote) {
        if (v.available && v.inventory !== null && threshold > 0 && v.inventory <= threshold) {
          stockNote.textContent = 'Only ' + v.inventory + ' left in this size';
        } else {
          stockNote.textContent = '';
        }
      }

      if (priceWrap) {
        var html = '<span data-price-current>' + v.price_formatted + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<s class="price__compare">' + v.compare_formatted + '</s><span class="badge">Sale</span>';
        }
        priceWrap.innerHTML = html;
      }
      if (stickyPrice) stickyPrice.innerHTML = v.price_formatted;

      if (v.media_id) {
        var item = section.querySelector('[data-media-id="' + v.media_id + '"]');
        var gallery = section.querySelector('[data-gallery]');
        if (item && gallery && window.matchMedia('(max-width: 899px)').matches) {
          gallery.scrollTo({ left: item.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
        }
      }

      if (pushUrl && document.body.classList.contains('template-product')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    radios.forEach(function (r) { r.addEventListener('change', function () { update(true); }); });
    update(false);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      addToCart(form, addBtn);
    });

    /* Mobile gallery counter */
    var gallery = section.querySelector('[data-gallery]');
    var counter = section.querySelector('[data-gallery-count]');
    if (gallery && counter) {
      var total = gallery.children.length;
      gallery.addEventListener('scroll', function () {
        var i = Math.round(gallery.scrollLeft / (gallery.children[0].offsetWidth + 6)) + 1;
        counter.textContent = Math.min(total, Math.max(1, i)) + ' / ' + total;
      }, { passive: true });
    }

    /* Sticky add to cart */
    var sticky = section.parentNode.querySelector('[data-sticky-atc]');
    if (sticky && 'IntersectionObserver' in window) {
      var stickyBtn = sticky.querySelector('[data-sticky-add]');
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0 && window.innerWidth < 900;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(addBtn);
      stickyBtn.addEventListener('click', function () {
        if (addBtn.disabled) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        addToCart(form, stickyBtn);
      });
    }
  }

  /* ---------- Collection filters ---------- */
  function initFilters() {
    var form = document.querySelector('[data-auto-submit]');
    if (!form) return;
    form.addEventListener('change', function () {
      var params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(function (k) { if (!params.get(k)) params.delete(k); });
      window.location.search = params.toString();
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (el) {
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  function init() {
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    initFilters();
    initRecommendations();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Re-init inside the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product-section]').forEach(initProduct);
  });
})();
